import * as types from '../actiontypes';

export function saveUploadDocumentId(documentId) {
	return {
		type: types.SAVE_UPLOAD_DOCUMENT_ID,
		documentId
	};
}

export function clearUploadDocumentIds() {
	return {
		type: types.CLEAR_UPLOAD_DOCUMENT_ID
	};
}

export function saveUploadDocuments(documents = []) {
	return {
		type: types.SAVE_UPLOAD_DOCUMENTS,
		documents
	};
}

export function updateUploadDocument(document) {
	return {
		type: types.UPDATE_UPLOAD_DOCUMENT,
		document
	};
}

export function clearUploadDocuments() {
	return {
		type: types.CLEAR_UPLOAD_DOCUMENTS
	};
}

export function removeUploadDocument() {
	return {
		type: types.REMOVE_UPLOAD_DOCUMENT
	};
}
